module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0091.jpg?v=83fcefb7";